<template>
  <BaseFormCard width="600" svg="analytic" ref="analyze-form-card">
    <template #title>วิเคราะห์ข้อมูล</template>
    <template #body>
      <v-layout v-if="!isShowResult" row wrap ma-0 pa-5>
        <v-flex xs12>
          <p class="subtitle-2 my-2">วันที่เกิดเหตุ</p>
          <v-layout>
            <v-flex xs5>
              <DatePicker
                v-model="startDate"
                :defaultDate="startDate"
                :max="today"
                @input="changeDate(utils.startDateChanged(startDate, endDate))"
              />
            </v-flex>
            <v-flex xs2 class="d-flex justify-center">
              <p class="subtitle-2 my-2 align-self-center">ถึง</p>
            </v-flex>
            <v-flex xs5>
              <DatePicker
                v-model="endDate"
                :defaultDate="endDate"
                :max="today"
                @input="changeDate(utils.endDateChanged(startDate, endDate))"
              />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <p class="subtitle-2 my-2">ช่วงเวลาที่เกิดเหตุ</p>
          <v-layout>
            <v-flex xs5>
              <TimePicker v-model="startTime" :defaultTime="startTime" :max="endTime" />
            </v-flex>
            <v-flex xs2 class="d-flex justify-center">
              <p class="subtitle-2 my-2 align-self-center">ถึง</p>
            </v-flex>
            <v-flex xs5>
              <TimePicker v-model="endTime" :defaultTime="endTime" :min="startTime" />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          :class="{
            xs12: $vuetify.breakpoint.width <= 700,
            'xs6 pr-1': $vuetify.breakpoint.width > 700
          }"
        >
          <p class="subtitle-2 my-2">วันที่รายงาน</p>
          <v-flex>
            <DatePicker v-model="reportDate" :max="today" :defaultDate="reportDate" />
          </v-flex>
        </v-flex>
        <v-flex
          :class="{
            xs12: $vuetify.breakpoint.width <= 700,
            'xs6 pl-1': $vuetify.breakpoint.width > 700
          }"
        >
          <p class="subtitle-2 my-2">เวลาที่รายงาน</p>
          <v-flex>
            <TimePicker v-model="reportTime" :defaultTime="reportTime" />
          </v-flex>
        </v-flex>

        <v-flex
          :class="{
            xs12: $vuetify.breakpoint.width <= 700,
            'xs4 pr-1': $vuetify.breakpoint.width > 700
          }"
        >
          <p class="subtitle-2 my-2">จังหวัด</p>
          <v-select
            v-model="provinceSelect"
            :items="provinceItems"
            item-text="name"
            item-value="id"
            no-data-text="ไม่พบข้อมูล"
            label="เลือกจังหวัด"
            class="card-border"
            flat
            solo
            hide-details
          ></v-select>
        </v-flex>
        <v-flex
          :class="{ xs12: $vuetify.breakpoint.width <= 700, xs4: $vuetify.breakpoint.width > 700 }"
        >
          <p class="subtitle-2 my-2">อำเภอ</p>
          <v-select
            v-model="amphoeSelect"
            :items="amphoeItems"
            item-text="name"
            item-value="id"
            no-data-text="ไม่พบข้อมูล"
            label="เลือกอำเภอ"
            class="card-border"
            flat
            solo
            hide-details
          ></v-select>
        </v-flex>
        <v-flex
          :class="{
            xs12: $vuetify.breakpoint.width <= 700,
            'xs4 pl-1': $vuetify.breakpoint.width > 700
          }"
        >
          <p class="subtitle-2 my-2">ตำบล</p>
          <v-select
            v-model="tambonSelect"
            :items="tambonItems"
            item-text="name"
            item-value="id"
            no-data-text="ไม่พบข้อมูล"
            label="เลือกตำบล"
            class="card-border"
            flat
            solo
            hide-details
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <p class="subtitle-2 my-2">หน่วยงาน</p>
          <v-select
            v-model="departmentSelect"
            :items="departmentItems"
            item-text="description"
            item-value="id"
            no-data-text="ไม่พบข้อมูล"
            label="เลือกหน่วยงาน"
            class="card-border"
            flat
            solo
            hide-details
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <p class="subtitle-2 my-2">รหัส/ชื่อสายทาง</p>
          <v-text-field
            hide-details
            label="ใส่รหัส / ชื่อสายทาง"
            placeholder="ใส่รหัส / ชื่อสายทาง"
            v-model="road"
            class="card-border"
            clearable
            my-auto
            solo
            flat
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <SelectedOptions
            :data-source="analyzeOptions"
            v-model="options"
            :editable="!isShowResult"
          />
        </v-flex>
        <v-flex xs12 class="pt-5">
          <v-card class="card-border" width="100%" height="100%" flat>
            <v-expansion-panels
              id="expansion-panels"
              v-model="expansionPanel"
              focusable
              expand-icon="mdi-menu-down"
              accordion
            >
              <template v-for="(item, index) in analyzeOptions">
                <v-expansion-panel :key="'expansion-panel-' + index">
                  <v-expansion-panel-header>{{ item.groupName }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <template v-for="(option, indexOption) in item.options">
                      <OptionDialogButton
                        :key="'optons-' + indexOption"
                        :title="option.title"
                        :type="option.type"
                        :label="option.label"
                        :data-source="option.data"
                        :showCheckboxControl="option.showCheckboxControl"
                        v-model="options[option.name]"
                        v-on:remove-key="removeKey(option.name)"
                      />
                    </template>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
            </v-expansion-panels>
          </v-card>
        </v-flex>
        <v-flex xs12 class="mt-10 mb-2 d-flex justify-center justify-sm-end">
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            rounded
            width="120"
            color="primary"
            @click="analyze"
            >ค้นหา</v-btn
          >
        </v-flex>
      </v-layout>
      <!-- Result -->
      <v-layout v-else row wrap ma-0 pa-5>
        <v-flex xs6 pr-1>
          <p class="subtitle-2 my-2">วันที่เกิดเหตุ</p>
          <v-text-field
            hide-details
            readonly
            class="card-border"
            my-auto
            solo
            flat
            :value="
              `${utils.formatToDateThai(startDate) || ''} - ${utils.formatToDateThai(endDate) ||
                ''}`
            "
          ></v-text-field>
        </v-flex>
        <v-flex xs6 pl-1>
          <p class="subtitle-2 my-2">ช่วงเวลาที่เกิดเหตุ</p>
          <v-text-field
            hide-details
            readonly
            class="card-border"
            my-auto
            solo
            flat
            :value="`${startTime ? startTime + ' น.' : ''} - ${endTime ? endTime + 'น.' : ''} `"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 pr-1>
          <p class="subtitle-2 my-2">สถานที่เกิดเหตุ</p>
          <v-text-field
            hide-details
            readonly
            class="card-border"
            my-auto
            solo
            flat
            :value="_accidentAreaText"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 mt-5>
          <p class="subtitle-2 primary--text my-2">สรุปผล</p>
        </v-flex>
        <v-flex xs4 pr-1>
          <p class="subtitle-2 my-2">จำนวนอุบัติเหตุ</p>
          <v-text-field
            hide-details
            readonly
            class="card-border"
            my-auto
            solo
            flat
            :value="_accidentCount"
          ></v-text-field>
        </v-flex>
        <v-flex xs8 pl-1>
          <p class="subtitle-2 my-2">สายทางที่เกิดอุบัติเหตุ</p>
          <v-text-field
            hide-details
            readonly
            class="card-border"
            my-auto
            solo
            flat
            :value="_roadCount"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <p class="subtitle-2 my-2">ความสูญเสียต่อตัวบุคคล</p>
          <v-text-field
            hide-details
            readonly
            class="card-border"
            my-auto
            solo
            flat
            :value="_personDamage"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 mt-5>
          <SelectedOptions
            :data-source="analyzeOptions"
            v-model="options"
            :editable="!isShowResult"
          />
        </v-flex>
        <v-flex xs12 class="pt-5">
          <!-- <highcharts :options="chartOptions"></highcharts> -->
          <ResultChart
            :options="resultGraph"
            :accidentCount="accidentCount"
            :data-source="analyzeOptions"
          />
        </v-flex>
        <v-flex xs6 class="mt-10 mb-2 d-flex">
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            rounded
            outlined
            width="120"
            color="primary"
            @click="csvExport"
            >ออกรายงาน</v-btn
          >
        </v-flex>
        <v-flex xs6 class="mt-10 mb-2 d-flex justify-center justify-sm-end">
          <v-btn
            v-show="isLogin"
            :block="$vuetify.breakpoint.xsOnly"
            rounded
            outlined
            width="120"
            color="primary"
            @click="gotoAccidentList"
            class="mr-2"
            >ดูรายการ</v-btn
          >
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            rounded
            outlined
            width="120"
            color="primary"
            @click="isShowResult = false"
            >แก้ไข</v-btn
          >
        </v-flex>
      </v-layout>
      <v-flex>
        <AlertDialog
          v-model="alertDialog"
          :status="'error'"
          v-on:ok-btn-click="alertDialog = false"
          >{{ alertMessage }}</AlertDialog
        >
      </v-flex>
    </template>
  </BaseFormCard>
</template>

<script>
import cloneDeep from 'clone-deep';
import BaseFormCard from './BaseFormCard.vue';
import DatePicker from '../global/DatePicker.vue';
import TimePicker from '../global/TimePicker.vue';
import OptionDialogButton from './analyze/OptionsDialogButton.vue';
import SelectedOptions from './analyze/SelectedOptions.vue';
import ResultChart from './analyze/ResultChart.vue';
import AlertDialog from '../global/AlertDialog';

const qs = require('qs');

export default {
  name: 'AnalyzeFormCard',
  components: {
    BaseFormCard,
    DatePicker,
    TimePicker,
    OptionDialogButton,
    SelectedOptions,
    ResultChart,
    AlertDialog
  },
  props: {
    map: {
      type: Object,
      default() {
        return {};
      }
    },
    isLogin: {
      type: Boolean
    },
    optionItems: {
      type: Object,
      default: () => {
        const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/search_option`;
        this.axios
          .get(url)
          .then(response => {
            if (response.status === 200 && response.data.data) {
              return response.data.data;
            }
          })
          .catch(error => {
            console.log(error);
            return {};
          });
      }
    }
  },
  data: () => ({
    alertDialog: false,
    alertMessage: '',
    isShowResult: false,
    //
    analyzeOptions: [
      {
        groupName: 'ข้อมูลผู้ใช้ทาง',
        options: [
          {
            title: 'เพศ',
            name: 'sex',
            type: 'checkbox',
            data: []
          },
          {
            title: 'อายุ',
            name: 'age',
            type: 'range',
            range: {
              min: 0,
              max: 120
            },
            label: 'ปี',
            data: []
          },
          {
            title: 'ประเภทผู้ใช้ทาง',
            name: 'vehicle_type',
            type: 'checkbox',
            data: []
          }
        ]
      },
      {
        groupName: 'ลักษณะการเกิดอุบัติเหตุ',
        options: [
          {
            title: 'รูปแบบการชน',
            name: 'crash_pattern',
            type: 'checkbox',
            data: []
          },
          {
            title: 'มูลเหตุสันนิษฐานหลัก',
            name: 'cause_main',
            type: 'checkbox',
            data: []
          },
          {
            title: 'มูลเหตุสันนิษฐานด้านผู้ขับขี่',
            name: 'cause_user',
            type: 'checkbox',
            data: []
          },
          {
            title: 'มูลเหตุสันนิษฐานด้านยานพาหนะ',
            name: 'cause_vehicle',
            type: 'checkbox',
            data: []
          },
          {
            title: 'มูลเหตุสันนิษฐานด้านสภาพทาง',
            name: 'cause_surround',
            type: 'checkbox',
            data: []
          }
        ]
      },
      {
        groupName: 'สภาพแวดล้อม/ทัศนวิสัย',
        options: [
          {
            title: 'แสงสว่าง',
            name: 'surround_light',
            type: 'checkbox',
            data: []
          },
          {
            title: 'สภาพภูมิอากาศ',
            name: 'surround_weather',
            type: 'checkbox',
            data: []
          }
        ]
      },
      {
        groupName: 'ลักษณะทางกายภาพของบริเวณที่เกิดอุบัติเหตุ',
        options: [
          {
            title: 'ลักษณะบริเวณที่เกิดเหตุ',
            name: 'surround_character',
            type: 'checkbox',
            data: []
          },
          {
            title: 'ผิวจราจร',
            name: 'class_surface',
            type: 'checkbox',
            data: []
          },
          {
            title: 'สภาพทาง',
            name: 'surround_road',
            type: 'checkbox',
            data: []
          },
          {
            title: 'คุณภาพผิวทาง',
            name: 'surround_road_quality',
            type: 'checkbox',
            data: []
          }
        ]
      },
      {
        groupName: 'ข้อมูลความเสียหาย',
        options: [
          {
            title: 'ความเสียหายต่อตัวบุคคล',
            name: 'wound',
            type: 'checkbox',
            data: []
          },
          {
            title: 'จำนวนผู้เสียชีวิต',
            name: 'dead',
            type: 'number',
            label: 'ราย',
            data: []
          },
          {
            title: 'จำนวนผู้บาดเจ็บ',
            name: 'injure',
            type: 'number',
            label: 'คน',
            data: []
          }
        ]
      },
      {
        groupName: 'ปัจจัยที่ส่งผลต่อความรุนแรง',
        options: [
          {
            title: 'ปัจจัยที่ส่งผลต่อความรุนแรง',
            name: 'damage_factor',
            type: 'checkbox',
            data: []
          }
        ]
      }
    ],
    //
    expansionPanel: [],
    //
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    reportDate: '',
    reportTime: '',
    //
    provinceSelect: '',
    provinceItems: [],
    amphoeSelect: '',
    amphoeItems: [],
    amphoeAllItems: [],
    tambonSelect: '',
    tambonItems: [],
    tambonAllItems: [],
    departmentSelect: '',
    departmentItems: [],
    road: '',
    // roadSelect: '',
    // roadItems: [],
    //
    options: {},
    resultGraph: {},
    //
    accidentCount: 0,
    roadCount: 0,
    deadCount: 0,
    injureCount: 0,
    pivot: [],
    today: null,
    accidentlist: []
  }),
  created() {
    this.getProvinceLists();
    // this.getAmphoeLists();
    // this.getTambonLists();
    this.getDepartmentLists();
  },
  mounted() {
    this.today = this.utils.getLocalDate();
  },
  methods: {
    deActivatebtn() {
      this.$refs['analyze-form-card'].closeClicked();
    },
    analyze() {
      if (this.startDate === '' || this.endDate === '') {
        this.alertMessage = 'กรุณาระบุวันที่เริ่มต้นและวันที่สิ้นสุด';
        this.alertDialog = true;
        return;
      }
      if (!Object.keys(this.options).length) {
        this.alertMessage = 'กรุณาเลือกข้อมูลการวิเคราะห์';
        this.alertDialog = true;
        return;
      }
      this.isShowResult = true;

      const scope = this;
      const search = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/map/accident_by_search`;
      const analyze = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/map/accident_by_analyze`;
      const params = {
        start_date: scope.startDate,
        end_date: scope.endDate,
        start_time: scope.startTime,
        end_time: scope.endTime,
        report_date: scope.reportDate,
        report_time: scope.reportTime,
        province: scope.provinceSelect,
        amphoe: scope.amphoeSelect,
        tambon: scope.tambonSelect,
        department: scope.departmentSelect,
        road: scope.road,
        ...scope.options
      };
      scope.axios
        .get(analyze, { params })
        .then(response => {
          if (response.status === 200 && response.data.data && response.data.data.accident_list.length) {
            const { data } = response.data;
            scope.accidentCount = data.count;
            scope.roadCount = data.road_count;
            scope.deadCount = data.dead;
            scope.injureCount = data.injury;
            scope.resultGraph = data.graph;
            scope.pivot = [this.getCSVHeader()];
            scope.getPivotRow([], data.pivot);
            scope.accidentlist = data.accident_list;
            scope.axios
              .post(search, 'id=' + data.accident_list.join(','))
              .then(response => {
                if (response.status === 200 && response.data.data) {
                  const data = response.data.data;
                  scope.$emit('pin-change', data);
                }
              })
              .catch(error => {
                console.error(error);
              });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    getCSVHeader() {
      const header = [];
      let unit = 1;
      const optionList = [
        ['sex', 'เพศ', 3],
        ['age', 'ช่วงอายุ', 3],
        ['vehicle_type', 'ประเภทยานพาหนะ', 2],
        ['crash_pattern', 'ลักษณะการชน', 1],
        ['cause_main', 'มูลเหตุสันนิษฐานหลัก', 1],
        ['cause_user', 'มูลเหตุสันนิษฐานจากผู้ขับขี่', 1],
        ['cause_vehicle', 'มูลเหตุสันนิษฐานจากยานพาหนะ', 1],
        ['cause_surround', 'มูลเหตุสันนิษฐานจากสภาพสายทาง', 1],
        ['surround_light', 'สภาพแสงสว่าง', 1],
        ['surround_weather', 'สภาพอากาศ', 1],
        ['surround_character', 'ลักษณะสายทาง', 1],
        ['class_surface', 'ลักษณะพื้นผิว', 1],
        ['surround_road', 'สภาพสายทาง', 1],
        ['surround_road_quality', 'คุณภาพสายทาง', 1],
        ['wound', 'ความรุนแรง', 3],
        ['dead', 'จำนวนผู้เสียชีวิต', 1],
        ['injure', 'จำนวนผู้บาดเจ็บ', 1],
        ['damage_factor', 'ปัจจัยที่ส่งผลต่อความรุนแรง', 1]
      ];
      for (const i in optionList) {
        if (this.options[optionList[i][0]]) {
          header.push(optionList[i][1]);
          unit = Math.max(unit, optionList[i][2]);
        }
      }

      switch (unit) {
        case 1:
          header.push('จำนวนครั้ง');
          break;
        case 2:
          header.push('จำนวนคัน');
          break;
        case 3:
          header.push('จำนวนคน');
      }
      return header;
    },
    removeKey(key) {
      const editedOptions = cloneDeep(this.options);
      delete editedOptions[key];
      this.options = editedOptions;
    },
    getProvinceLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/province`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.provinceItems = response.data.data;
            scope.provinceItems.unshift({ id: '', name: 'เลือกทุกจังหวัด' });
          }
        })
        .catch(error => {
          scope.provinceItems = [];
          console.log(error);
        });
    },
    getAmphoeLists() {
      // if (!this.provinceSelect) return;

      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/amphoe/${this.provinceSelect}`;
      // const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/amphoe/0`;

      // if (scope.amphoeAllItems.length == 0) {
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            // scope.amphoeItems = response.data.data;

            // scope.amphoeAllItems = response.data.data;
            if (scope.provinceSelect) {
              scope.amphoeItems = response.data.data;
              scope.amphoeItems.unshift({ id: '', name: 'เลือกทุกอำเภอ' });
              // scope.amphoeAllItems.forEach(function(obj) {
              //   if (scope.provinceSelect == obj.province) {
              //     scope.amphoeItems.push(obj);
              //   }
              // });
            }

            // if (scope.amphoeTempId) {
            //   scope.amphoeItems.forEach(function (obj) {
            //     if (scope.amphoeTempId == obj.id) {
            //       scope.amphoeSelect = obj;
            //     }
            //   });

            //   scope.amphoeTempId = null;
            //   scope.getTambonLists();
            // }
          }
        })
        .catch(error => {
          scope.amphoeItems = [];
          console.log(error);
        });
      // } else if (scope.provinceSelect) {
      //   scope.amphoeItems = [];
      //   scope.amphoeAllItems.forEach(function(obj) {
      //     if (scope.provinceSelect == obj.province) {
      //       scope.amphoeItems.push(obj);
      //     }
      //   });
      // }
    },
    getTambonLists() {
      // if (!this.provinceSelect || !this.amphoeSelect) return;

      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/tambon/${this.provinceSelect}/${this.amphoeSelect}`;
      // const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/tambon/0`;

      // if (scope.tambonAllItems.length == 0) {
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            // scope.tambonAllItems = response.data.data;
            if (scope.provinceSelect && scope.amphoeSelect) {
              scope.tambonItems = response.data.data;
              scope.tambonItems.unshift({ id: '', name: 'เลือกทุกตำบล' });
              // scope.tambonAllItems.forEach(function(obj) {
              //   if (
              //     scope.provinceSelect.id == obj.province &&
              //     scope.amphoeSelect.id == obj.amphoe
              //   ) {
              //     scope.tambonItems.push(obj);
              //   }
              // });
            }
          }
        })
        .catch(error => {
          scope.tambonItems = [];
          console.log(error);
        });
      // } else if (scope.provinceSelect && scope.amphoeSelect) {
      //   scope.tambonItems = [];
      //   scope.tambonAllItems.forEach(function(obj) {
      //     if (scope.provinceSelect == obj.province && scope.amphoeSelect == obj.amphoe) {
      //       scope.tambonItems.push(obj);
      //     }
      //   });
      // }
    },
    getDepartmentLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/department`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.departmentItems = response.data.data;
            if (scope.departmentItems.length > 0)
              scope.departmentItems.unshift({
                id: 0,
                name: '',
                description: 'เลือกทุกหน่วยงาน'
              });
          }
        })
        .catch(error => {
          scope.departmentItems = [];
          console.log(error);
        });
    },
    gotoAccidentList() {
      localStorage.setItem('accidentListStDate', this.startDate);
      localStorage.setItem('accidentListEdDate', this.endDate);
      localStorage.setItem('accidentListProvince', this.provinceSelect);
      localStorage.setItem('accidentListDepartment', this.departmentSelect);
      localStorage.setItem('accidentListRoad', this.road);
      this.$emit('goto-list', this.accidentlist);
    },
    csvExport() {
      // console.log(this.pivot);
      let csvContent = 'data:text/csv;charset=utf-8,\uFEFF';
      csvContent += this.pivot.map(row => row.join(',')).join('\n');

      const data = encodeURI(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', this.getDownloadFilename());
      link.click();
    },
    getDownloadFilename() {
      const name = this.utils
        .getLocalTime()
        .toJSON()
        .substring(0, 19)
        .replace('T', '_')
        .replace(/-|:/g, '');
      return `analyze-${name}.csv`;
    },
    getPivotRow(fullKey, obj) {
      for (const key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          this.getPivotRow(fullKey.concat([`"${key}"`]), obj[key]);
        } else {
          this.pivot.push(fullKey.concat([`"${key}"`, obj[key]]));
        }
      }
    },
    changeDate(period) {
      if (period) {
        if (period.startDate != this.startDate) {
          this.startDate = period.startDate;
        }
        if (period.endDate != this.endDate) {
          this.endDate = period.endDate;
        }
      }
    }
  },
  computed: {
    _accidentCount() {
      return `${new Intl.NumberFormat().format(this.accidentCount)} ครั้ง`;
    },
    _roadCount() {
      return `${new Intl.NumberFormat().format(this.roadCount)} สายทาง`;
    },
    _personDamage() {
      return `ผู้เสียชีวิต ${new Intl.NumberFormat().format(
        this.deadCount
      )} คน, ผู้บาดเจ็บสาหัส ${new Intl.NumberFormat().format(
        this.injureCount
      )} คน, ผู้บาดเจ็บเล็กน้อย ${new Intl.NumberFormat().format(
        this.resultGraph.wound_amount ? this.resultGraph.wound_amount[2] : 0
      )} คน`;
    },
    _accidentAreaText() {
      if (this.provinceSelect === '') {
        return 'ทั้งประเทศ';
      }
      const provinceText = `จ. ${this.provinceName}`;
      const amphoeText = `อ. ${this.amphoeName}`;
      const tambonText = `ต. ${this.tambonName}`;

      return `${provinceText}${this.amphoeSelect !== '' ? ` ${amphoeText}` : ''}${
        this.tambonSelect !== '' ? ` ${tambonText}` : ''
      }`;
    },
    provinceName() {
      const province = this.provinceItems.filter(x => {
        return x.id === this.provinceSelect;
      });
      if (province.length === 1) {
        return province[0].name;
      }
      return '';
    },
    amphoeName() {
      const amphoe = this.amphoeItems.filter(x => x.id === this.amphoeSelect);
      if (amphoe.length === 1) {
        return amphoe[0].name;
      }
      return '';
    },
    tambonName() {
      const tambon = this.tambonItems.filter(x => x.id === this.tambonSelect);
      if (tambon.length === 1) {
        return tambon[0].name;
      }
      return '';
    }
  },
  watch: {
    provinceSelect() {
      this.amphoeSelect = '';
      this.amphoeItems = [];
      this.getAmphoeLists();
    },
    amphoeSelect() {
      this.tambonSelect = '';
      this.tambonItems = [];
      this.getTambonLists();
    },
    optionItems(val) {
      this.analyzeOptions = [
        {
          groupName: 'ข้อมูลผู้ใช้ทาง',
          options: [
            {
              title: 'เพศ',
              name: 'sex',
              type: 'checkbox',
              data: val.casualty_sex || []
            },
            {
              title: 'อายุ',
              name: 'age',
              type: 'range',
              range: {
                min: 0,
                max: 120
              },
              label: 'ปี',
              data: []
            },
            {
              title: 'ประเภทผู้ใช้ทาง',
              name: 'vehicle_type',
              type: 'checkbox',
              data: val.vehicle || []
            }
          ]
        },
        {
          groupName: 'ลักษณะการเกิดอุบัติเหตุ',
          options: [
            {
              title: 'รูปแบบการชน',
              name: 'crash_pattern',
              type: 'checkbox',
              data: val.accident_pattern || []
            },
            {
              title: 'มูลเหตุสันนิษฐานหลัก',
              name: 'cause_main',
              type: 'checkbox',
              data: val.cause_main || []
            },
            {
              title: 'มูลเหตุสันนิษฐานด้านผู้ขับขี่',
              name: 'cause_user',
              type: 'checkbox',
              data: val.cause_user || []
            },
            {
              title: 'มูลเหตุสันนิษฐานด้านยานพาหนะ',
              name: 'cause_vehicle',
              type: 'checkbox',
              data: val.cause_vehicle || []
            },
            {
              title: 'มูลเหตุสันนิษฐานด้านสภาพทาง',
              name: 'cause_surround',
              type: 'checkbox',
              data: val.cause_surround || []
            }
          ]
        },
        {
          groupName: 'สภาพแวดล้อม/ทัศนวิสัย',
          options: [
            {
              title: 'แสงสว่าง',
              name: 'surround_light',
              type: 'checkbox',
              data: val.surround_light || []
            },
            {
              title: 'สภาพภูมิอากาศ',
              name: 'surround_weather',
              type: 'checkbox',
              data: val.surround_weather || []
            }
          ]
        },
        {
          groupName: 'ลักษณะทางกายภาพของบริเวณที่เกิดอุบัติเหตุ',
          options: [
            {
              title: 'ลักษณะบริเวณที่เกิดเหตุ',
              name: 'surround_character',
              type: 'checkbox',
              data: val.surround_character || []
            },
            {
              title: 'ผิวจราจร',
              name: 'class_surface',
              type: 'checkbox',
              data: val.surface || []
            },
            {
              title: 'สภาพทาง',
              name: 'surround_road',
              type: 'checkbox',
              data: val.surround_road || []
            },
            {
              title: 'คุณภาพผิวทาง',
              name: 'surround_road_quality',
              type: 'checkbox',
              data: val.surround_road_quality || []
            }
          ]
        },
        {
          groupName: 'ข้อมูลความเสียหาย',
          options: [
            {
              title: 'ความเสียหายต่อตัวบุคคล',
              name: 'wound',
              type: 'checkbox',
              data: val.casualty_damage || []
            },
            {
              title: 'จำนวนผู้เสียชีวิต',
              name: 'dead',
              type: 'number',
              label: 'ราย',
              data: []
            },
            {
              title: 'จำนวนผู้บาดเจ็บ',
              name: 'injure',
              type: 'number',
              label: 'คน',
              data: []
            }
          ]
        },
        {
          groupName: 'ปัจจัยที่ส่งผลต่อความรุนแรง',
          options: [
            {
              title: 'ปัจจัยที่ส่งผลต่อความรุนแรง',
              name: 'damage_factor',
              type: 'checkbox',
              data: val.damage_factor || []
            }
          ]
        }
      ];
    }
  }
};
</script>
<style lang="scss" scoped></style>
